import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const OverlayContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${(props) => props.theme.blackToBlack};
    z-index: 99999;
    opacity: 0.7;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    & span{
    font-size: ${theme.font.size16};
    color: #ffffff;
    }
`;
